import { gql } from '@apollo/client';
import { sectionFragment } from '../../../../graphql/fragments';

export const GET_SECTIONS = gql`
    query Sections {
        sections {
            id
            name
            createdAt
            ordering
            places {
                id
                name
                isToGo
                coordinateX
                coordinateY
            }
        }
    }
`;

export const GET_SECTION_TABS = gql`
    query SectionsFragment {
        sections {
            ...SectionsFragment
            createdAt
            ordering
        }
    }
    ${sectionFragment}
`;
